<template>
  <div
    class="c-app flex-row align-items-center"
    style="
         height: 100%;
        background-position: center;
        width: 100%;"
  >
    <CWrapper>
      <CHeader fixed with-subheader light style="position: fixed;">
        <CToggler
          in-header
          class="ml-3 d-lg-none"
          @click="$store.commit('toggleSidebarMobile')"
        />
        <CToggler
          in-header
          class="ml-3 d-md-down-none"
          @click="$store.commit('toggleSidebarDesktop')"
        />
        <CHeaderBrand class="d-lg-none">
          <h3>
            <b> <font color="Green">HAULING SITE</font></b>
          </h3>
        </CHeaderBrand>
        <CHeaderNav class="d-md-down-none mr-auto">
          <CHeaderNavItem class="px-3">
            <h3>
              <b> <font color="Green">HAULING SITE</font></b>
            </h3>
          </CHeaderNavItem>
        </CHeaderNav>
      </CHeader>
      <div class="c-body">
        <main class="c-main">
          <CRow>
            <CCol class="amsys-dashboard-parameter">
              <select
                class="form-control"
                style="font-weight: bold; font-size:18px;"
                @change="reloadCoal()"
                v-model="selectedData"
              >
                <option value="ALL" selected="selected">
                  ALL
                </option>
                <option
                  v-for="item in companyResult"
                  :value="item.Oid"
                  :key="item.Code"
                >
                  {{ item.Code }}
                </option>
              </select>
            </CCol>
          </CRow>
          <!--<CRow>
        <CCol class="amsys-dashboard-parameter">
            <select class="form-control" style="font-weight: bold; font-size:18px;"  @change="reloadCoal()"  v-model="selectedHauling">
                <option value="DISCHARGE" selected="selected">
                    DISCHARGE
                </option>
                <option value="LOADING">
                    LOADING
                </option>
            </select>
        </CCol>
    </CRow>-->
          <CRow>
            <CCol class="amsys-dashboard-parameter2">
              <select
                class="form-control"
                style="font-weight: bold; font-size:18px;"
                @change="reloadMonth()"
                v-model="selectedMonth"
              >
                <option value="1">
                  JAN
                </option>
                <option value="2">
                  FEB
                </option>
                <option value="3">
                  MAR
                </option>
                <option value="4">
                  APR
                </option>
                <option value="5">
                  MEI
                </option>
                <option value="6">
                  JUN
                </option>
                <option value="7">
                  JUL
                </option>
                <option value="8">
                  AUG
                </option>
                <option value="9">
                  SEP
                </option>
                <option value="10">
                  OCT
                </option>
                <option value="11">
                  NOV
                </option>
                <option value="12">
                  DEC
                </option>
              </select>
            </CCol>
            <br />
            <CCol class="amsys-dashboard-parameter2">
              <select
                class="form-control"
                style="font-weight: bold; font-size:18px;"
                @change="reloadYear()"
                v-model="selectedYear"
              >
                <option
                  v-for="year in years()"
                  v-if="year >= 2015"
                  :value="year"
                  >{{ year }}</option
                >
              </select>
            </CCol>
          </CRow>
          <br />
          <CRow class="amsys-dashboard-row">
            <CCol class="amsys-dashboard-frame">
              <div class="card">
                <div class="card-header" style="background-color:Green;">
                  <h5>
                    <b> <font color="white">MONTHLY SITE</font></b>
                  </h5>
                </div>
                <div class="card-body">
                  <CCol style="width: 100%;padding: 0px;">
                    <DxChart
                      v-if="selectedHauling == 'DISCHARGE'"
                      id="chart1"
                      :data-source="company1"
                      :customize-label="customizeLabel"
                      palette="Harmony Light"
                    >
                      <DxCommonSeriesSettings
                        argument-field="type"
                        type="bar"
                        hover-mode="allArgumentPoints"
                      >
                        <DxLabel :visible="false">
                          <DxFormat :precision="0" type="fixedPoint" />
                        </DxLabel>
                      </DxCommonSeriesSettings>
                      <DxSeries
                        value-field="discharge"
                        axis="frequency"
                        type="spline"
                        name="Days"
                      />
                      <DxSeries
                        value-field="cummulative"
                        axis="percentage"
                        type="spline"
                        name="Month-To-Date"
                      >
                      </DxSeries>
                      <DxValueAxis
                        :tick-interval="1500"
                        name="frequency"
                        position="left"
                      />
                      <DxValueAxis
                        :tick-interval="2000"
                        :show-zero="true"
                        :value-margins-enabled="false"
                        name="percentage"
                        position="right"
                      >
                        <DxLabel :customize-text="customizeText" />
                        <DxConstantLine
                          :value="80"
                          :width="2"
                          color="#fc3535"
                          dash-style="dash"
                        >
                          <DxLabel :visible="false" />
                        </DxConstantLine>
                      </DxValueAxis>
                      <DxTooltip
                        :enabled="true"
                        :shared="true"
                        :customize-tooltip="customizeTooltip"
                      />
                      <DxLegend
                        vertical-alignment="top"
                        horizontal-alignment="center"
                      />
                    </DxChart>
                    <DxChart
                      v-if="selectedHauling == 'LOADING'"
                      id="chart1"
                      :data-source="company1"
                      :customize-label="customizeLabel"
                      palette="Harmony Light"
                    >
                      <DxCommonSeriesSettings
                        argument-field="type"
                        type="bar"
                        hover-mode="allArgumentPoints"
                      >
                        <DxLabel :visible="false">
                          <DxFormat :precision="0" type="fixedPoint" />
                        </DxLabel>
                      </DxCommonSeriesSettings>
                      <DxSeries
                        value-field="loading"
                        axis="frequency"
                        type="spline"
                        name="Days"
                      />
                      <DxSeries
                        value-field="cummulative"
                        axis="percentage"
                        type="spline"
                        name="Month-To-Date"
                      >
                      </DxSeries>
                      <DxValueAxis
                        :tick-interval="1500"
                        name="frequency"
                        position="left"
                      />
                      <DxValueAxis
                        :tick-interval="2000"
                        :show-zero="true"
                        :value-margins-enabled="false"
                        name="percentage"
                        position="right"
                      >
                        <DxLabel :customize-text="customizeText" />
                        <DxConstantLine
                          :value="80"
                          :width="2"
                          color="#fc3535"
                          dash-style="dash"
                        >
                          <DxLabel :visible="false" />
                        </DxConstantLine>
                      </DxValueAxis>

                      <DxTooltip
                        :enabled="true"
                        :shared="true"
                        :customize-tooltip="customizeTooltip"
                      />

                      <DxLegend
                        vertical-alignment="top"
                        horizontal-alignment="center"
                      />
                    </DxChart>
                  </CCol>
                </div>
              </div>
            </CCol>
          </CRow>
          <br />
          <CRow class="amsys-dashboard-row">
            <CCol class="amsys-dashboard-frame">
              <div class="card">
                <div class="card-header" style="background-color:Green;">
                  <h5>
                    <b> <font color="white">YEARLY SITE</font></b>
                  </h5>
                </div>
                <div class="card-body">
                  <CCol style="width: 100%;padding: 0px;">
                    <DxChart
                      v-if="selectedHauling == 'DISCHARGE'"
                      id="chart3"
                      :data-source="company3"
                      :customize-label="customizeLabel"
                      palette="Harmony Light"
                    >
                      <DxCommonSeriesSettings
                        argument-field="type"
                        type="bar"
                        hover-mode="allArgumentPoints"
                      >
                        <DxLabel :visible="false">
                          <DxFormat :precision="0" type="fixedPoint" />
                        </DxLabel>
                      </DxCommonSeriesSettings>
                      <DxSeries
                        value-field="discharge"
                        axis="frequency"
                        type="spline"
                        name="Monthly"
                      />
                      <DxSeries
                        value-field="cummulative"
                        axis="percentage"
                        type="spline"
                        name="Year-To-Date"
                      >
                      </DxSeries>
                      <DxValueAxis
                        :tick-interval="20000"
                        name="frequency"
                        position="left"
                      />
                      <DxValueAxis
                        :tick-interval="20000"
                        :show-zero="true"
                        :value-margins-enabled="false"
                        name="percentage"
                        position="right"
                      >
                        <DxLabel :customize-text="customizeText" />
                        <DxConstantLine
                          :value="20"
                          :width="2"
                          color="#fc3535"
                          dash-style="dash"
                        >
                          <DxLabel :visible="false" />
                        </DxConstantLine>
                      </DxValueAxis>
                      <DxTooltip
                        :enabled="true"
                        :shared="true"
                        :customize-tooltip="customizeTooltip"
                      />
                      <DxLegend
                        vertical-alignment="top"
                        horizontal-alignment="center"
                      />
                    </DxChart>

                    <DxChart
                      v-if="selectedHauling == 'LOADING'"
                      id="chart3"
                      :data-source="company3"
                      :customize-label="customizeLabel"
                      palette="Harmony Light"
                    >
                      <DxCommonSeriesSettings
                        argument-field="type"
                        type="bar"
                        hover-mode="allArgumentPoints"
                      >
                        <DxLabel :visible="false">
                          <DxFormat :precision="0" type="fixedPoint" />
                        </DxLabel>
                      </DxCommonSeriesSettings>
                      <DxSeries
                        value-field="loading"
                        axis="frequency"
                        type="spline"
                        name="Monthly"
                      />
                      <DxSeries
                        value-field="cummulative"
                        axis="percentage"
                        type="spline"
                        name="Year-To-Date"
                      >
                      </DxSeries>
                      <DxValueAxis
                        :tick-interval="20000"
                        name="frequency"
                        position="left"
                      />
                      <DxValueAxis
                        :tick-interval="20000"
                        :show-zero="true"
                        :value-margins-enabled="false"
                        name="percentage"
                        position="right"
                      >
                        <DxLabel :customize-text="customizeText" />
                        <DxConstantLine
                          :value="20"
                          :width="2"
                          color="#fc3535"
                          dash-style="dash"
                        >
                          <DxLabel :visible="false" />
                        </DxConstantLine>
                      </DxValueAxis>
                      <DxTooltip
                        :enabled="true"
                        :shared="true"
                        :customize-tooltip="customizeTooltip"
                      />
                      <DxLegend
                        vertical-alignment="top"
                        horizontal-alignment="center"
                      />
                    </DxChart>
                  </CCol>
                </div>
              </div>
            </CCol>
          </CRow>
          <br />
          <CRow class="amsys-dashboard-row">
            <CCol class="amsys-dashboard-frame">
              <div class="card">
                <div class="card-header" style="background-color:Green;">
                  <h5>
                    <b> <font color="white">SITE SUMMARY BY VENDOR</font></b>
                  </h5>
                </div>
                <div class="card-body">
                  <CCol style="width: 100%;padding: 0px;">
                    <DxPieChart
                      v-if="selectedHauling == 'DISCHARGE'"
                      id="pie"
                      :data-source="company2"
                      palette="Bright"
                    >
                      <DxSeries argument-field="company" value-field="qty">
                        <DxLabel
                          :visible="false"
                          :customize-text="formatLabel"
                          position="columns"
                        >
                          <DxConnector :visible="true" :width="0.5" />
                          <DxFont :size="16" />
                        </DxLabel>
                      </DxSeries>
                      <DxLegend
                        :column-count="4"
                        orientation="horizontal"
                        item-text-position="right"
                        horizontal-alignment="center"
                        vertical-alignment="bottom"
                      />
                      <DxTooltip
                        :enabled="true"
                        :customize-tooltip="pieCustomizeTooltip"
                      />
                      <DxExport :enabled="false" />
                    </DxPieChart>

                    <DxPieChart
                      v-if="selectedHauling == 'LOADING'"
                      id="pie"
                      :data-source="company2"
                      palette="Bright"
                    >
                      <DxSeries argument-field="company" value-field="qty">
                        <DxLabel
                          :visible="false"
                          :customize-text="formatLabel"
                          position="columns"
                        >
                          <DxConnector :visible="true" :width="0.5" />
                          <DxFont :size="16" />
                        </DxLabel>
                      </DxSeries>
                      <DxLegend
                        :column-count="4"
                        orientation="horizontal"
                        item-text-position="right"
                        horizontal-alignment="center"
                        vertical-alignment="bottom"
                      />
                      <DxTooltip
                        :enabled="true"
                        :customize-tooltip="pieCustomizeTooltip"
                      />
                      <DxExport :enabled="false" />
                    </DxPieChart>
                  </CCol>
                </div>
              </div>
            </CCol>
          </CRow>
          <br />
          <CRow class="amsys-dashboard-row">
            <CCol class="amsys-dashboard-frame">
              <div class="card">
                <div class="card-header" style="background-color:Green;">
                  <h5>
                    <b>
                      <font color="white"
                        >{{ selectedHauling }} SUMMARY BY STOCK CODE</font
                      ></b
                    >
                  </h5>
                </div>
                <div class="card-body">
                  <CCol style="width: 100%;padding: 0px;">
                    <DxPieChart
                      v-if="selectedHauling == 'DISCHARGE'"
                      id="pie"
                      :data-source="company4"
                      palette="Bright"
                    >
                      <DxSeries argument-field="code" value-field="qty">
                        <DxLabel
                          :visible="false"
                          :customize-text="formatLabel"
                          position="columns"
                        >
                          <DxConnector :visible="true" :width="0.5" />
                          <DxFont :size="16" />
                        </DxLabel>
                      </DxSeries>
                      <DxLegend
                        :column-count="4"
                        orientation="horizontal"
                        item-text-position="right"
                        horizontal-alignment="center"
                        vertical-alignment="bottom"
                      />
                      <DxTooltip
                        :enabled="true"
                        :customize-tooltip="pieCustomizeTooltip"
                      />
                      <DxExport :enabled="false" />
                    </DxPieChart>

                    <DxPieChart
                      v-if="selectedHauling == 'LOADING'"
                      id="pie"
                      :data-source="company4"
                      palette="Bright"
                    >
                      <DxSeries argument-field="code" value-field="qty">
                        <DxLabel
                          :visible="false"
                          :customize-text="formatLabel"
                          position="columns"
                        >
                          <DxConnector :visible="true" :width="0.5" />
                          <DxFont :size="16" />
                        </DxLabel>
                      </DxSeries>
                      <DxLegend
                        :column-count="4"
                        orientation="horizontal"
                        item-text-position="right"
                        horizontal-alignment="center"
                        vertical-alignment="bottom"
                      />
                      <DxTooltip
                        :enabled="true"
                        :customize-tooltip="pieCustomizeTooltip"
                      />
                      <DxExport :enabled="false" />
                    </DxPieChart>
                  </CCol>
                </div>
              </div>
            </CCol>
          </CRow>
          <br />
        </main>
      </div>
    </CWrapper>
  </div>
</template>
<script>
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import { DxPieChart, DxConnector } from "devextreme-vue/pie-chart";
import {
  DxSeries,
  DxLegend,
  DxLabel,
  DxFont,
  DxExport,
  DxTooltip,
  DxChart,
  DxCommonSeriesSettings,
  DxArgumentAxis,
  DxGrid,
  DxCrosshair,
  DxPoint,
  DxTitle,
  DxSubtitle,
  DxValueAxis,
} from "devextreme-vue/chart";
import TheSidebar from "../../containers/TheSidebar";
import TheHeader from "../../containers/TheHeader";
import nav from "../../containers/_nav";
import Vue from "vue";
import axios from "axios";
import "@babel/polyfill";
import VueCordova from "vue-cordova";
import CryptoJS from "crypto-js";
Vue.use(VueCordova);

export default {
  components: {
    DxChart,
    DxCommonSeriesSettings,
    DxSeries,
    DxArgumentAxis,
    DxGrid,
    DxCrosshair,
    DxExport,
    DxLegend,
    DxPoint,
    DxLabel,
    DxFont,
    DxTitle,
    DxSubtitle,
    DxTooltip,
    TheSidebar,
    TheHeader,
    DxValueAxis,
    DxPieChart,
    DxConnector,
  },
  nav,
  computed: {},
  data() {
    return {
      selectedYear: new Date().getFullYear(),
      selectedMonth: new Date().getMonth() + 1,
      companyResult: [],
      coalStockResult: [],
      selectedData: "ALL",
      selectedCoalStock: "ALL",
      selectedHauling: "LOADING",
      company1: [],
      company2: [],
      company3: [],
      company4: [],
      month: "",
      year: "",
      data: [],
      data2: [],
      data4: [],
      showHeader: false,

      urlServer: "",
    };
  },
  methods: {
    formatLabel(pointInfo) {
      return `${pointInfo.percentText}`;
    },
    show() {
      return this.$store.state.sidebarShow;
    },
    Minimize() {
      return this.$store.state.sidebarMinimize;
    },
    customizeLabel({ value }) {
      return {
        customizeText: function({ valueText }) {
          return `${valueText
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
        },
      };
    },
    customizeText({ valueText }) {
      return `${valueText
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
    },
    customizeTooltip(pointInfo) {
      return {
        text: `${pointInfo.argumentText}
                            <br/>${pointInfo.value
                              .toFixed(2)
                              .toString()
                              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`,
      };
    },
    pieCustomizeTooltip(pointInfo) {
      return {
        text: `${pointInfo.argumentText}
                            <br/>${pointInfo.value
                              .toFixed(2)
                              .toString()
                              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                            <br/>${pointInfo.percentText}`,
      };
    },
    years() {
      const year = new Date().getFullYear();
      return Array.from(
        { length: year - 1900 },
        (value, index) => 1901 + index
      );
    },
    reloadCoal() {
      this.coalStock();
      this.reloadData();
      this.reloadDataMonthly();
      this.reloadDataYearly();
    },
    reloadCoalStock() {
      this.reloadData();
      this.reloadDataMonthly();
      this.reloadDataYearly();
    },
    reloadMonth() {
      this.reloadData();
      this.reloadDataMonthly();
    },
    reloadYear() {
      this.reloadData();
      this.reloadDataMonthly();
      this.reloadDataYearly();
    },

    coalStock() {
      let data = localStorage.token;

      const form = new FormData();
      form.append("Company", this.selectedData);
      let sendData = JSON.stringify(Object.fromEntries(form));
      if (typeof data != "undefined") {
        axios
          .post(`${this.urlServer}/Api/General/GetCoalStock/`, sendData, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
              "Access-Control-Allow-Headers":
                "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
              "Content-Type": "application/json",
              Authorization: "Bearer " + data,
            },
          })
          .then((res) => {
            console.log(res);
            this.coalStockResult = res.data;
            this.selectedCoalStock = "ALL";
          })
          .catch((error) => {
            let err = error.toString();
            if (err.toString().match(/^.*undefined.*$/)) {
              Vue.$toast.open({
                message: "Sorry, Your token has expired!",
                type: "warning",
                position: "bottom",
              });
              this.$router.push({ path: "/logout" });
            } else {
              Vue.$toast.open({
                message: error,
                type: "error",
                position: "bottom",
              });
            }
          });
      } else {
        this.$router.push({ path: "/logout" });
      }
    },
    reloadData() {
      let data = localStorage.token;
      const param = {
        Month: this.selectedMonth,
        Year: this.selectedYear,
        COid: this.selectedData,
        CsOid: this.selectedCoalStock,
      };
      if (this.selectedData != "undefined") {
        this.data = new Array();
        this.company = new Array();

        const items = [this.selectedData];
        this.data = [{ value: [this.selectedData], name: [this.selectedData] }];

        if (typeof data != "undefined") {
          var hauling = new Array();
          var mon = "";

          if (this.selectedHauling != "LOADING") {
            axios
              .post(
                `${this.urlServer}/Api/CoalStock/GetMonthlyDischargeHaulingData1/`,
                param,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + data,
                  },
                }
              )
              .then((res) => {
                var i, x;
                for (i = 0; i < res.data.length; i++) {
                  var mon1 = res.data[i].Date;
                  if (mon1 != mon) {
                    var objs = new Object();
                    objs["type"] = mon1;
                    for (x = 0; x < res.data.length; x++) {
                      if (res.data[i].Date == res.data[x].Date) {
                        if (res.data[x].Type == "Discharge") {
                          objs["discharge"] = res.data[x].Total;
                        } else {
                          objs["cummulative"] = res.data[x].Total;
                        }
                      }
                    }
                    hauling.push(objs);
                    mon = mon1;
                  }
                }
                this.company1 = hauling;
                this.loading = false;
              })
              .catch((error) => {
                this.loading = false;
                console.error(error);
              });
          } else {
            axios
              .post(
                `${this.urlServer}/Api/CoalStock/GetMonthlyLoadingData1/`,
                param,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + data,
                  },
                }
              )
              .then((res) => {
                var i, x;
                for (i = 0; i < res.data.length; i++) {
                  var mon1 = res.data[i].Date;
                  if (mon1 != mon) {
                    var objs = new Object();
                    objs["type"] = mon1;
                    for (x = 0; x < res.data.length; x++) {
                      if (res.data[i].Date == res.data[x].Date) {
                        if (res.data[x].Type == "Loading") {
                          objs["loading"] = res.data[x].Total;
                        } else {
                          objs["cummulative"] = res.data[x].Total;
                        }
                      }
                    }
                    hauling.push(objs);
                    mon = mon1;
                  }
                }
                this.company1 = hauling;
                this.loading = false;
              })
              .catch((error) => {
                this.loading = false;
                console.error(error);
              });
          }
        } else {
          this.loading = false;
          this.$router.push({ path: "/logout" });
        }
      } else {
      }
      this.loading = false;
    },
    reloadDataMonthly() {
      let data = localStorage.token;
      const param = {
        Month: this.selectedMonth,
        Year: this.selectedYear,
        COid: this.selectedData,
        CsOid: this.selectedCoalStock,
      };

      if (this.selectedData != "undefined") {
        this.data = new Array();
        this.company = new Array();

        const items = [this.selectedData];
        this.data = [{ value: [this.selectedData], name: [this.selectedData] }];

        if (typeof data != "undefined") {
          var hauling = new Array();
          var hauling1 = new Array();
          var mon = "";

          if (this.selectedHauling != "LOADING") {
            axios
              .post(
                `${this.urlServer}/Api/CoalStock/GetMonthlyDischargeHaulingData/`,
                param,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + data,
                  },
                }
              )
              .then((res) => {
                res.data.forEach(function(entry) {
                  var obj = new Object();
                  obj["company"] = entry.TransporterGroup;
                  obj["qty"] = parseFloat(entry.Total.toFixed(2));
                  hauling.push(obj);
                });
                this.company2 = hauling;
                this.loading = false;
              })
              .catch((error) => {
                this.loading = false;
                console.error(error);
              });

            axios
              .post(
                `${this.urlServer}/Api/CoalStock/GetMonthlyDischargeHaulingDataByStockCode/`,
                param,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + data,
                  },
                }
              )
              .then((res) => {
                console.log(res.data);
                res.data.forEach(function(entry) {
                  var obj = new Object();
                  obj["code"] = entry.CoalStockCode;
                  obj["qty"] = parseFloat(entry.Total.toFixed(2));
                  hauling1.push(obj);
                });
                this.company4 = hauling1;
                this.loading = false;
              })
              .catch((error) => {
                this.loading = false;
                console.error(error);
              });
          } else {
            axios
              .post(
                `${this.urlServer}/Api/CoalStock/GetMonthlyLoadingData/`,
                param,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + data,
                  },
                }
              )
              .then((res) => {
                res.data.forEach(function(entry) {
                  var obj = new Object();
                  obj["company"] = entry.TransporterGroup;
                  obj["qty"] = parseFloat(entry.Total.toFixed(2));
                  hauling.push(obj);
                });
                this.company2 = hauling;
                this.loading = false;
              })
              .catch((error) => {
                this.loading = false;
                console.error(error);
              });

            axios
              .post(
                `${this.urlServer}/Api/CoalStock/GetMonthlyLoadingDataByStockCode/`,
                param,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + data,
                  },
                }
              )
              .then((res) => {
                console.log(res.data);
                res.data.forEach(function(entry) {
                  var obj = new Object();
                  obj["code"] = entry.CoalStockCode;
                  obj["qty"] = parseFloat(entry.Total.toFixed(2));
                  hauling1.push(obj);
                });
                this.company4 = hauling1;
                this.loading = false;
              })
              .catch((error) => {
                this.loading = false;
                console.error(error);
              });
          }
        } else {
          this.loading = false;
          this.$router.push({ path: "/logout" });
        }
      } else {
      }
      this.loading = false;
    },
    reloadDataYearly() {
      let data = localStorage.token;
      const param = {
        Year: this.selectedYear,
        COid: this.selectedData,
        CsOid: this.selectedCoalStock,
      };
      if (this.selectedData != "undefined") {
        this.data = new Array();
        this.company = new Array();

        const items = [this.selectedData];
        this.data = [{ value: [this.selectedData], name: [this.selectedData] }];

        if (typeof data != "undefined") {
          var hauling = new Array();
          var mon = "";

          if (this.selectedHauling != "LOADING") {
            axios
              .post(
                `${this.urlServer}/Api/CoalStock/GetYearlyDischargeHaulingData1/`,
                param,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + data,
                  },
                }
              )
              .then((res) => {
                var i, x;
                for (i = 0; i < res.data.length; i++) {
                  var mon1 = res.data[i].Month;
                  if (mon1 != mon) {
                    var objs = new Object();
                    objs["type"] = mon1;
                    for (x = 0; x < res.data.length; x++) {
                      if (res.data[i].Month == res.data[x].Month) {
                        if (res.data[x].Type == "Discharge") {
                          objs["discharge"] = res.data[x].Total;
                        } else {
                          objs["cummulative"] = res.data[x].Total;
                        }
                      }
                    }
                    hauling.push(objs);
                    mon = mon1;
                  }
                }
                this.company3 = hauling;
                this.loading = false;
              })
              .catch((error) => {
                this.loading = false;
                console.error(error);
              });
          } else {
            axios
              .post(
                `${this.urlServer}/Api/CoalStock/GetYearlyLoadingData/`,
                param,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + data,
                  },
                }
              )
              .then((res) => {
                var i, x;
                for (i = 0; i < res.data.length; i++) {
                  var mon1 = res.data[i].Month;
                  if (mon1 != mon) {
                    var objs = new Object();
                    objs["type"] = mon1;
                    for (x = 0; x < res.data.length; x++) {
                      if (res.data[i].Month == res.data[x].Month) {
                        if (res.data[x].Type == "Loading") {
                          objs["loading"] = res.data[x].Total;
                        } else {
                          objs["cummulative"] = res.data[x].Total;
                        }
                      }
                    }
                    hauling.push(objs);
                    mon = mon1;
                  }
                }
                this.company3 = hauling;
                this.loading = false;
              })
              .catch((error) => {
                this.loading = false;
                console.error(error);
              });
          }
        } else {
          this.loading = false;
          this.$router.push({ path: "/logout" });
        }
      } else {
      }
      this.loading = false;
    },
  },
  beforeMount() {
    this.loading = true;
    const stringToProtect = "Amsys_2@2021";
    let url = CryptoJS.AES.decrypt(localStorage.url, stringToProtect);
    const urlS = url.toString(CryptoJS.enc.Utf8);
    this.urlServer = urlS;
    const formatYmd = (date) => date.toISOString().slice(0, 10);
    var d = new Date();
    var now = formatYmd(d);
    console.log(now);
    this.Sd = now;
    this.Ed = now;
    let data = localStorage.token;
    const param = { Company: "PT. CAKRAWALA DINAMIKA ENERGI", Year: "2019" };
    const form = new FormData();
    form.append("CompanyOid", this.selectedData);
    let sendData = JSON.stringify(Object.fromEntries(form));
    if (typeof data != "undefined") {
      axios
        .post(`${urlS}/Api/General/GetCompany/`, sendData, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          console.log(res);
          this.companyResult = res.data;
        })
        .catch((error) => {
          let err = error.toString();
          if (err.toString().match(/^.*undefined.*$/)) {
            Vue.$toast.open({
              message: "Sorry, Your token has expired!",
              type: "warning",
              position: "bottom",
            });
            this.$router.push({ path: "/logout" });
          } else {
            Vue.$toast.open({
              message: error,
              type: "error",
              position: "bottom",
            });
          }
        });
    } else {
      this.$router.push({ path: "/logout" });
    }
    this.coalStock();
    this.reloadData();
    this.reloadDataMonthly();
    this.reloadDataYearly();
    this.loading = false;
  },
};
</script>
<style>
#chart {
  height: 440px;
}

.tooltip-header {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 5px;
  border-bottom: 1px solid #c5c5c5;
}

.tooltip-body {
  width: 170px;
}

.tooltip-body .series-name {
  font-weight: normal;
  opacity: 0.6;
  display: inline-block;
  line-height: 1.5;
  padding-right: 10px;
  width: 126px;
}

.tooltip-body .value-text {
  display: inline-block;
  line-height: 1.5;
  width: 30px;
}
</style>
